import { Navigate } from "react-router-dom";
import { useAuth } from "kmstack-shared/providers";
import React from "react";

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
    const { loading, isAuthenticated } = useAuth();

    if (loading) return null;

    if (isAuthenticated) {
        return <Navigate to="/account" replace />;
    }

    return children;
};
